import React, { useEffect, useRef } from "react";
import "./ImageModal.css";

export default function ImageModal({ open, src, alt = "", onClose }) {
  const dialogRef = useRef(null);

  // Fermer via ESC + bloquer le scroll de la page quand ouvert
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    dialogRef.current?.focus();
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="imgmodal-overlay-imgcs"
      role="dialog"
      aria-modal="true"
      aria-label={alt || "Aperçu de l'image"}
      onClick={onClose}
      tabIndex={-1}
      ref={dialogRef}
    >
      <div
        className="imgmodal-content-imgcs"
        onClick={(e) => e.stopPropagation()} // éviter de fermer en cliquant sur l'image
      >
        <img className="imgmodal-img-imgcs" src={src} alt={alt} />
      </div>
    </div>
  );
}
